import React, { useState } from "react";
import { ServicePackage, ServicePackageCreateDTO } from "../../BillingAPI";
import "../../BillingStyles.scss";
import { formatCurrency, serviceIdToName } from "../../helpers/utils";
import { formatDateStandar } from "../../../../../helpers/utils";
import Modal, { Styles } from "react-modal";
import ClipLoader from "react-spinners/ClipLoader";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import {
  createOrUpdateServicePackage,
  getClientServicePackages,
  selectUpdatePackageLoading,
} from "../../BillingSlice";
import { selectUserId } from "../../../../common/commonSlice";
import { DropDown } from "../../../../common/components/Btns/DropDown";
import isEmail from "validator/lib/isEmail";

export interface ServicePackageRenderProps {
  servicePackage?: ServicePackage;
  create?: boolean;
  displayMode?: boolean;
  clientId: string;
}
Modal.setAppElement("#root");
const customStylesModalCreateOrUpdadatePackage: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "75%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};

export const ServicePackageRender = (props: ServicePackageRenderProps) => {
  const dispatch = useAppDispatch();
  const updateOrCreateLoading = useAppSelector(selectUpdatePackageLoading);
  const userId = useAppSelector(selectUserId);
  const [
    modalCreateOrUpdatePackageIsOpen,
    setModalCreateOrUpdatePackageIsOpen,
  ] = useState(false);

  const [createOrUpdateReq, setCreateOrUpdateReq] =
    useState<ServicePackageCreateDTO>(undefined);
  const [inputEmail, setInputEmail] = useState("");

  const serviceOptions = [
    { value: "VALID", label: "VALID" },
    { value: "COREID", label: "CoreID" },
    { value: "FORMS", label: "Formularios" },
    { value: "FIRMA", label: "Firma Electrónica" },
    { value: "PAGARE", label: "Pagares" },
    { value: "BIO_AUTH", label: "Autenticación Biométrica" },
  ];
  const getLatestRecharge = () => {
    if (props.servicePackage.recharges.length > 0) {
      return props.servicePackage.recharges[
        props.servicePackage.recharges.length - 1
      ];
    }
    return null;
  };

  const cantCreateOrUpdate = () => {
    if (createOrUpdateReq) {
      if (createOrUpdateReq.id) {
        return false;
      } else {
        if (
          createOrUpdateReq?.newAlertEmails &&
          createOrUpdateReq?.newAlertEmails?.length > 0
        ) {
          if (!createOrUpdateReq?.newAlertValue) {
            return true;
          } else if (createOrUpdateReq?.newAlertEmails?.length > 5) {
            return true;
          }
        }
        if (!createOrUpdateReq?.rechargeCost) {
          return true;
        } else if (!createOrUpdateReq?.rechargeValue) {
          return true;
        } else if (!createOrUpdateReq?.service) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  };

  const createOrUpdateRender = () => {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          className="text-large text-bold"
          style={{
            textAlign: "center",
            fontSize: "18px",
            marginBottom: "15px",
          }}
        >
          {createOrUpdateReq && createOrUpdateReq.id
            ? "Editar Paquete"
            : "Crear Paquete"}
        </div>
        {createOrUpdateReq && createOrUpdateReq.id ? (
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 15px 0",
            }}
          >
            A continuación, puedes editar la siguiente información del paquete
          </p>
        ) : (
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 15px 0",
            }}
          >
            A continuación, debes ingresar la siguiente información para crear
            el paquete.
          </p>
        )}
        {updateOrCreateLoading === "rejected" && (
          <p
            style={{
              fontSize: "13px",
              color: "#cf4259",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            Hubo un error creando el paquete
          </p>
        )}
        <DropDown
          key={"service"}
          title={"Servicio"}
          maxContent
          options={serviceOptions}
          bgColor="#1A617D"
          alignCenter
          titleColor="#1A617D"
          onChange={(e) => {
            if (e) {
              setCreateOrUpdateReq({ ...createOrUpdateReq, service: e.value });
            }
          }}
          defaultValue={{
            label: "VALID",
            value: "VALID",
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "12px",
            width: "90%",
            alignSelf: "center",
          }}
        >
          <label
            htmlFor="rechargeValue"
            style={{
              width: "100%",
              marginRight: "10px",
              alignSelf: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
            }}
          >
            <p
              style={{
                fontSize: "13px",
                color: "#000",
                fontWeight: "500",
                textAlign: "start",
                margin: "0 0 2px 2px",
              }}
            >
              Valor de la recarga (valor a consumir)
            </p>
            <input
              onChange={(e) => {
                if (e && e.target.value) {
                  if (Number.isNaN(Number(e.target.value))) {
                    setCreateOrUpdateReq({
                      ...createOrUpdateReq,
                      rechargeValue: undefined,
                    });
                    return;
                  } else {
                    setCreateOrUpdateReq({
                      ...createOrUpdateReq,
                      rechargeValue: Number(e.target.value),
                    });
                  }
                } else {
                  setCreateOrUpdateReq({
                    ...createOrUpdateReq,
                    rechargeValue: undefined,
                  });
                }
              }}
              id="rechargeValue"
              name="rechargeValue"
              type="text"
              placeholder="(Ej: 10000)"
              value={createOrUpdateReq?.rechargeValue || "0"}
              style={{
                border: "1px solid rgba(0,0,0,0.5)",
                borderRadius: "6px",
                background: "transparent",
                padding: "8px 8px 8px 8px",
                minHeight: "24px",
                fontSize: "12px",
                fontWeight: "500",
                textAlign: "start",
                color: "#000",
                width: "100%",
              }}
            />
          </label>
          <label
            htmlFor="rechargeCost"
            style={{
              width: "100%",
              marginRight: "10px",
              alignSelf: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
            }}
          >
            <p
              style={{
                fontSize: "13px",
                color: "#000",
                fontWeight: "500",
                textAlign: "start",
                margin: "0 0 2px 2px",
              }}
            >
              Costo de la recarga (valor a pagar en pesos)
            </p>
            <input
              onChange={(e) => {
                if (e && e.target.value) {
                  if (Number.isNaN(Number(e.target.value))) {
                    setCreateOrUpdateReq({
                      ...createOrUpdateReq,
                      rechargeCost: undefined,
                    });
                    return;
                  } else {
                    setCreateOrUpdateReq({
                      ...createOrUpdateReq,
                      rechargeCost: Number(e.target.value),
                    });
                  }
                } else {
                  setCreateOrUpdateReq({
                    ...createOrUpdateReq,
                    rechargeCost: undefined,
                  });
                }
              }}
              id="rechargeCost"
              name="rechargeCost"
              type="text"
              placeholder="(Ej: 5000000)"
              value={createOrUpdateReq?.rechargeCost || "0"}
              style={{
                border: "1px solid rgba(0,0,0,0.5)",
                borderRadius: "6px",
                background: "transparent",
                padding: "8px 8px 8px 8px",
                minHeight: "24px",
                fontSize: "12px",
                fontWeight: "500",
                textAlign: "start",
                color: "#000",
                width: "100%",
              }}
            />
          </label>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "12px",
            width: "90%",
            alignSelf: "center",
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          <label
            htmlFor="alertValue"
            style={{
              width: "40%",
              marginRight: "10px",
              alignSelf: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
            }}
          >
            <p
              style={{
                fontSize: "13px",
                color: "#000",
                fontWeight: "500",
                textAlign: "start",
                margin: "0 0 2px 2px",
              }}
            >
              Valor de alerta (si el valor de la recarga llega a este valor se
              notifica por correo)
            </p>
            <input
              onChange={(e) => {
                if (e && e.target.value) {
                  if (Number.isNaN(Number(e.target.value))) {
                    setCreateOrUpdateReq({
                      ...createOrUpdateReq,
                      newAlertValue: undefined,
                    });
                    return;
                  } else {
                    setCreateOrUpdateReq({
                      ...createOrUpdateReq,
                      newAlertValue: Number(e.target.value),
                    });
                  }
                } else {
                  setCreateOrUpdateReq({
                    ...createOrUpdateReq,
                    newAlertValue: undefined,
                  });
                }
              }}
              id="alertValue"
              name="alertValue"
              type="text"
              placeholder="(Ej: 5000000)"
              value={createOrUpdateReq?.newAlertValue || "0"}
              style={{
                border: "1px solid rgba(0,0,0,0.5)",
                borderRadius: "6px",
                background: "transparent",
                padding: "8px 8px 8px 8px",
                minHeight: "24px",
                fontSize: "12px",
                fontWeight: "500",
                textAlign: "start",
                color: "#000",
                width: "100%",
              }}
            />
          </label>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "50%",
              alignItems: "center",
            }}
          >
            <p
              style={{
                fontSize: "12px",
                fontWeight: 700,
                color: "#000",
                margin: 0,
              }}
            >
              Ingresa correos para recibir alertas
            </p>
            <label
              className="flex-col"
              style={{ width: "100%", alignItems: "center" }}
            >
              <div
                className="flex-row"
                style={{ width: "100%", justifyContent: "center" }}
              >
                <input
                  style={{
                    width: "70%",
                    height: "40px",
                    border:
                      inputEmail.length > 0 && !isEmail(inputEmail)
                        ? "1px solid rgba(200,0,12,0.3)"
                        : "1px solid rgba(0,0,0,0.3)",
                    boxSizing: "border-box",
                    padding: "10px",
                    borderRadius: "6px",
                    textAlign: "start",
                  }}
                  type="email"
                  value={inputEmail}
                  onChange={(e) => {
                    setInputEmail(e.target.value);
                  }}
                />
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    if (createOrUpdateReq?.newAlertEmails) {
                      setCreateOrUpdateReq({
                        ...createOrUpdateReq,
                        newAlertEmails: [
                          ...createOrUpdateReq?.newAlertEmails,
                          inputEmail,
                        ],
                      });
                    } else {
                      setCreateOrUpdateReq({
                        ...createOrUpdateReq,
                        newAlertEmails: [inputEmail],
                      });
                    }
                    setInputEmail("");
                  }}
                  disabled={inputEmail.length === 0 || !isEmail(inputEmail)}
                  style={{
                    border: "none",
                    textAlign: "center",
                    borderRadius: "8px 8px",
                    background: "rgba(13,60,80,1)",
                    paddingTop: "5px",
                    marginLeft: "5px",
                    paddingBottom: "5px",
                    paddingRight: "10px",
                    paddingLeft: "10px",
                    color: "#fff",
                  }}
                >
                  Agregar
                </button>
              </div>
              {inputEmail.length > 0 && !isEmail(inputEmail) && (
                <p
                  style={{
                    width: "70%",
                    fontSize: "10px",
                    color: "#cf4259",
                    margin: "2px 0 0 0",
                    textAlign: "start",
                  }}
                >
                  El correo ingresado no es válido
                </p>
              )}
            </label>
            <div
              className="flex-col"
              style={{
                height:
                  createOrUpdateReq?.newAlertEmails?.length > 10
                    ? "500px"
                    : "auto",
                overflow: "auto",
                width: "70%",
                padding: "15px",
              }}
            >
              {createOrUpdateReq?.newAlertEmails?.length > 0 && (
                <p style={{ fontSize: "12px", fontWeight: 700, color: "#000" }}>
                  Correos a los cuales se enviará el enlace
                </p>
              )}
              {createOrUpdateReq?.newAlertEmails &&
                createOrUpdateReq?.newAlertEmails.map((email, i) => {
                  return (
                    <div
                      key={i}
                      className="flex-row"
                      style={{ alignItems: "center" }}
                    >
                      <div
                        key={email}
                        className="flex-row"
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "5px 10px",
                          background: "rgba(0,0,0,0.2)",
                          borderRadius: "8px",
                          margin: "5px 0",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: "#000",
                          }}
                        >
                          {email}
                        </div>
                      </div>
                      <button
                        style={{
                          marginLeft: "5px",
                          border: "none",
                          textAlign: "center",
                          height: "25px",
                          width: "25px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "9999px",
                          background: "rgba(13,60,80,1)",
                          color: "#fff",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          let newAlertEmails = [
                            ...createOrUpdateReq?.newAlertEmails,
                          ];
                          newAlertEmails = newAlertEmails.filter(
                            (e) => e !== email
                          );
                          setCreateOrUpdateReq({
                            ...createOrUpdateReq,
                            newAlertEmails: newAlertEmails,
                          });
                        }}
                      >
                        x
                      </button>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div
          className="flex-row"
          style={{
            width: "80%",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "10px",
            alignSelf: "center",
          }}
        >
          <button
            onClick={(e) => {
              setModalCreateOrUpdatePackageIsOpen(false);
              setCreateOrUpdateReq(undefined);
              e.preventDefault();
            }}
            className="flex-col text-medium text-bold"
            style={{
              background: "transparent",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "1px solid #1A617D",
              color: "#1A617D",
            }}
          >
            Cancelar
          </button>
          <button
            disabled={
              updateOrCreateLoading === "pending" || cantCreateOrUpdate()
            }
            onClick={(e) => {
              e.preventDefault();
              if (createOrUpdateReq) {
                dispatch(createOrUpdateServicePackage(createOrUpdateReq)).then(
                  (x) => {
                    if (x.meta.requestStatus === "fulfilled") {
                      setModalCreateOrUpdatePackageIsOpen(false);
                      setCreateOrUpdateReq(undefined);
                      dispatch(getClientServicePackages(props.clientId));
                    }
                  }
                );
              }
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "none",
            }}
          >
            {updateOrCreateLoading === "pending" ? (
              <ClipLoader color="white" size={"20px"} />
            ) : (
              "Confirmar"
            )}
          </button>
        </div>
      </div>
    );
  };
  if (props.create) {
    return (
      <div>
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModalCreateOrUpdadatePackage}
          isOpen={modalCreateOrUpdatePackageIsOpen}
          onRequestClose={() => {
            setCreateOrUpdateReq(undefined);
            setModalCreateOrUpdatePackageIsOpen(false);
          }}
        >
          {createOrUpdateRender()}
        </Modal>
        <div className="service-card">
          <h6 className="service-card__title">{`Para agregar paquetes hagalo aquí`}</h6>
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                alignItems: "center",
              }}
            >
              <p className="service-card__label">Crear paquete de creditos</p>
              <button
                style={{
                  backgroundColor: "rgba(0,0,0,0.2)",
                  marginTop: "10px",
                  border: "none",
                  borderRadius: "6px",
                  minHeight: "30px",
                  width: "80%",
                  fontSize: "14px",
                }}
                className="primary-color"
                onClick={() => {
                  setCreateOrUpdateReq({
                    clientId: props.clientId,
                    service: "VALID",
                    rechargedBy: userId,
                  });
                  setModalCreateOrUpdatePackageIsOpen(true);
                }}
              >
                Crear uno nuevo
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <Modal
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        shouldFocusAfterRender
        shouldReturnFocusAfterClose
        style={customStylesModalCreateOrUpdadatePackage}
        isOpen={modalCreateOrUpdatePackageIsOpen}
        onRequestClose={() => {
          setCreateOrUpdateReq(undefined);
          setModalCreateOrUpdatePackageIsOpen(false);
        }}
      >
        {createOrUpdateRender()}
      </Modal>
      <div className="service-card" style={{ alignItems: "center" }}>
        <h6 className="service-card__title">{`Paquete de creditos: ${serviceIdToName(
          props.servicePackage.service
        )}`}</h6>
        <div>
          <div>
            <p className="service-card__label">Creditos Actuales Paquete</p>
            <p className="service-card__value">
              {props.servicePackage.currentValue}
            </p>
          </div>
          <div>
            <p className="service-card__label">
              Creditos de alerta (minimo para alertar)
            </p>
            <p className="service-card__value">
              {props.servicePackage.alertValue}
            </p>
          </div>
          <div>
            <p className="service-card__label">
              Creditos cargados originalmente
            </p>
            <p className="service-card__value">
              {getLatestRecharge().rechargeValue}
            </p>
          </div>
          {getLatestRecharge() && (
            <div>
              <p className="service-card__label">Valor Paquete</p>
              <p className="service-card__value">
                {formatCurrency(getLatestRecharge().rechargeCost)}
              </p>
            </div>
          )}
          {getLatestRecharge() && (
            <div>
              <p className="service-card__label">Fecha última recarga</p>
              <p className="service-card__value">
                {formatDateStandar(getLatestRecharge().rechargedAt)}
              </p>
            </div>
          )}
        </div>
        {!props.displayMode && (
          <p className="service-card__label">Correos de alerta</p>
        )}
        {!props.displayMode && props.servicePackage.alertEmails.length > 0 && (
          <div>
            {props.servicePackage.alertEmails.map((email, index) => (
              <div key={index}>
                <ul className="service-card__constraint-list">
                  <li> {email}</li>
                </ul>
              </div>
            ))}
          </div>
        )}
        {!props.displayMode && (
          <button
            style={{
              backgroundColor: "rgba(0,0,0,0.2)",
              marginTop: "10px",
              border: "none",
              borderRadius: "6px",
              minHeight: "30px",
              width: "80%",
              fontSize: "14px",
            }}
            className="primary-color"
            onClick={() => {
              setCreateOrUpdateReq({
                id: props.servicePackage.id,
                clientId: props.clientId,
                service: props.servicePackage.service,
                rechargedBy: userId,
                newAlertEmails: props.servicePackage.alertEmails,
                newAlertValue: props.servicePackage.alertValue,
              });
              setModalCreateOrUpdatePackageIsOpen(true);
            }}
          >
            Actualizar
          </button>
        )}
      </div>
    </div>
  );
};
